import { render, staticRenderFns } from "./NotificationAlarm.vue?vue&type=template&id=f221cf52"
import script from "./NotificationAlarm.vue?vue&type=script&lang=js"
export * from "./NotificationAlarm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports